
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profil/[id]",
      function () {
        return require("private-next-pages/profil/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profil/[id]"])
      });
    }
  